export const dayColors = [
  { time: 0, color: "#F2D5A2" }, // Dawn
  { time: 15, color: "#FBE58A" }, // Morning
  { time: 30, color: "#87CEEB" }, // Noon
  { time: 45, color: "#2D68C4" }, // Evening
  { time: 60, color: "#000033" }, // Night
];
